import React from "react";
import "./Services.css";
import { Link } from "react-router-dom";
import { IoCall } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa";
import { FaCalendarCheck } from "react-icons/fa6";


const serviceData = [
  {
    title: "Transferts Aéroport",
    image: "/assets/images/airporttransfert.png",
    description:
      "Prise en charge fluide depuis et vers l’aéroport de Nice Côte d’Azur, Cannes-Mandelieu et autres aéroports de la région.",
  },
  {
    title: "Chauffeur Privé pour Événements & Conférences",
    image: "/assets/images/privatedriver.png",
    description: "Chauffeur Privé pour Événements & Conférences",
  },
  {
    title: "Transferts Point à Point",
    image: "/assets/images/pointapoint.jpeg",
    description:
      "Trajets efficaces et luxueux entre villes ou au sein de la région.",
  },
  {
    title: "Transferts Portuaires & Croisières",
    image: "/assets/images/porttransfert.jpeg",
    description:
      "Transport direct vers ou depuis les ports de Nice, Villefranche-sur-Mer, Cannes et Monaco.",
  },
  {
    title: "Services d’Entreprise",
    image: "/assets/images/entreprise.jpeg",
    description:
      "Solutions sur mesure pour dirigeants, clients VIP et délégations professionnelles.",
  },
];

const Services = () => {
  return (
    <div>
      <section className="dark">
        <div className="container py-4">
          <h1 className="titles text-center" id="pageHeaderTitle">
            Nos Services
          </h1>

          {serviceData.map((service, index) => (
            <article
              key={index}
              className={`postcard dark ${["blue", "red", "green", "yellow", "blue"][index % 5]}`}
            >
              <Link className="postcard__img_link" to="#">
                <img
                loading="lazy"
                  className="postcard__img"
                  src={service.image}
                  alt={service.title}
                />
              </Link>
              <div className="postcard__text">
                <h1 className="postcard__title">
                  <Link to="#" className="text-decoration-none">
                    {service.title}
                  </Link>
                </h1>
                <div className="postcard__bar"></div>
                <div className="postcard__preview-txt">{service.description}</div>
                <ul className="postcard__tagbox">
                  <li className="tag__item vtc-button">
                    <Link
                      to="tel:+33661585885"
                      className="text-decoration-none"
                      style={{ color: "gold" }}
                    >
                      <IoCall /> Appelez-nous
                    </Link>
                  </li>

                  <li className="tag__item vtc-button whatsapp-button">
                    <a
                      href="https://wa.me/33661585885?text=Hello%20I%20would%20like%20to%20make%20a%20reservation"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <FaWhatsapp style={{ color: "green", margin: "3px" }} />
                      WhatsApp
                    </a>
                  </li>

                  <li className="tag__item play blue">
                    <Link to="/bookingForm" className="text-decoration-none">
                      <FaCalendarCheck
                        style={{ color: "#967438", margin: "3px" }}
                      />
                      Réserver maintenant
                    </Link>
                  </li>
                </ul>
              </div>
            </article>
          ))}
        </div>
      </section>
     
    </div>
  );
};

export default Services;
